import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import styles from './PublicDonation.module.css';
import { createOnlineDonation } from './api';
import { DonationFormState } from './types';

interface Props {
  fundId: number;
  form: DonationFormState;
  paymentType: string;
  onError: (message: string) => void;
}

const OnlineRedirectStep = ({ fundId, form, paymentType, onError }: Props) => {
  const { t, i18n } = useTranslation();
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (submitted) return;
    setSubmitted(true);
    const isBit = paymentType === 'Bit';
    const callbackBaseUrl = isBit
      ? `${window.location.origin}/new/donate/result?fundId=${fundId}`
      : `${window.location.origin}/new/donate/result?lang=${i18n.language}&fundId=${fundId}`;
    createOnlineDonation(fundId, {
      paymentType,
      donorFirstName: form.donor.firstName,
      donorLastName: form.donor.lastName,
      donorIsraeliId: form.donor.israeliId,
      donorPhone: form.donor.phone,
      donorEmail: form.donor.email,
      donorAddress: form.donor.address,
      donorCity: form.donor.city,
      amount: form.amount,
      currency: form.currency,
      callbackBaseUrl,
    })
      .then((res) => {
        if (res.redirectUrl) setRedirectUrl(res.redirectUrl);
        else { setHasError(true); onError(res.message || t('donations.unknownError')); }
      })
      .catch((e: AxiosError) => {
        setHasError(true);
        const serverMessage = typeof e.response?.data === 'string' ? e.response.data : null;
        onError(serverMessage || t('donations.unknownError'));
      });
  }, [fundId, form, paymentType, onError, i18n.language, t, submitted]);

  useEffect(() => {
    if (redirectUrl) window.location.href = redirectUrl;
  }, [redirectUrl]);

  if (hasError) return null;

  return <div className={styles.iframeLoading}>{t('donations.redirecting')}</div>;
};

export default OnlineRedirectStep;
